// extracted by mini-css-extract-plugin
module.exports = {"detail":"Details_detail__yY7Hp","return-form-check-on-next":"Details_return-form-check-on-next___wv_d","gRecaptchaa":"Details_gRecaptchaa__wvqVK"};